import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {Location} from "@angular/common";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


  

 counterblock = [

   {
      "id":1,
      "title":"INSTITUT",
      "text":"Sed ut perspiciatis unde omnis iste natus error sit voluptsantium doloremque laudantium",
      "icon":"assets/images/imagesAssets/school.png",
      "value":1
  },
  {
      "id":2,
      "title":"DEPARTEMENTS",
      "text":"Sed ut perspiciatis unde omnis iste natus error sit voluptsantium doloremque laudantium",
      "icon":"assets/images/imagesAssets/department.png",
      "value":2
  },
  {
      "id":3,
      "title":"SECTIONS",
      "text":"Sed ut perspiciatis unde omnis iste natus error sit voluptsantium doloremque laudantium",
      "icon":"assets/images/imagesAssets/education.png",
      "value":6
  },
  {
      "id":4,
      "title":"FORMATIONS",
      "text":"Sed ut perspiciatis unde omnis iste natus error sit voluptsantium doloremque laudantium",
      "icon":"assets/images/imagesAssets/graduated.png",
      "value":15
  },
 
]

  constructor(private route:Router) { }

  ngOnInit(): void {
   

  }


 

  admissionMaster(type){
    this.route.navigate(['/admissionDetail'], {queryParams:{data:type}})
}

}
